export const useRouteHelpers = () => {
  const route = useRoute()

  const isRouteMatch = (routePatterns: string[]): boolean => {
    const routeName = route.name?.toString()
    return routePatterns.some(pattern => routeName?.includes(pattern))
  }

  const isDetailPage = (): boolean => {
    const routeName = route.name?.toString()
    const routePath = route.path
    
    const topLevelRoutes = ['index', 'properties', 'training', 'services', 'portfolio']
    const detailRoutes = ['property-hash', 'properties-id', 'profile', 'login', 'signup', 'training-slug']
    
    if (topLevelRoutes.some(topRoute => routeName === topRoute || routeName?.includes(`${topRoute}-index`))) {
      return false
    }
    
    // Special case for portfolio route - always show search
    if (routePath === '/portfolio' || routeName === 'portfolio') {
      return false
    }
    
    if (detailRoutes.some(detailRoute => routeName?.includes(detailRoute))) {
      return true
    }
    
    if (route.params && Object.keys(route.params).length > 0) {
      return true
    }
    
    const pathSegments = routePath.split('/').filter(segment => segment.length > 0)
    const lastSegment = pathSegments[pathSegments.length - 1]
    const topLevelPathNames = ['training', 'services', 'properties']
    
    if (pathSegments.length > 1 && !topLevelPathNames.includes(lastSegment)) {
      return true
    }
    
    if (pathSegments.length > 2) {
      return true
    }
    
    if (routePath.includes('/payment/') || routePath.includes('/admin/')) {
      return true
    }
    
    return false
  }

  const hasQueryParam = (param: string, value?: string): boolean => {
    const queryValue = route.query?.[param]
    if (value) {
      return queryValue === value || queryValue === 'true' || queryValue === '1'
    }
    return !!queryValue
  }

  return {
    isRouteMatch,
    isDetailPage,
    hasQueryParam
  }
}